export const passwordREGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.,_+*?^!@#$\-()[\]{}|\\]).{6,}$/;
export const charactersREGX = /^(?=.*[a-zA-Z]).{6,}$/;
export const lowerCaseREGX = /^(?=.*[a-z]).+$/;
export const upperCaseREGX = /^(?=.*[A-Z]).+$/;
export const digitSpecialCharacterREGEX = /(?=.*[.,_+*?^!@#$\-()[\]{}|\\])/;
